// Put your application javascript here
$(document).ready(function() {
  window.addEventListener('keyup', (e) => {
    if (e.ctrlKey && e.shiftKey && e.which === 76) {
      if (document.getElementById('griddle')) {
        document.getElementById('griddle').remove()
      } else {
        let griddle = document.createElement('div')
        griddle.id = 'griddle'
        griddle.setAttribute('class', 'griddle-container')
        document.body.appendChild(griddle)
        for (let x = 0; x < 24; x++) {
          let griddleColumn = document.createElement('div')
          griddleColumn.setAttribute('class', 'griddle-column')
          griddle.appendChild(griddleColumn)
        }
      }
    }
  })

  function toggleAccordion () {
    let $accordionHeader = $('.accordion-header');
    $accordionHeader.on('click', function() {
      $(this).closest('.accordion-item').find('.copy').slideToggle();
    })
  }

  toggleAccordion()
});